import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  averageLowestFare: number;
  currentMinFare: number;
}

enum Compare {
  HIGH = 1,
  LOW = -1,
  SIMILAR = 0,
}

export default function Summary({ averageLowestFare, currentMinFare }: IProps) {
  const diff = ((currentMinFare - averageLowestFare) / averageLowestFare) * 100;
  const rounded = Math.round(Math.abs(diff));
  const compare =
    Math.abs(diff) <= 2
      ? Compare.SIMILAR
      : diff > 0
      ? Compare.HIGH
      : Compare.LOW;
  if (!compare) {
    return (
      <>
        <b className={cx('current')}>평균과 비슷</b>
        <span className={cx('desc')} role="row">
          검색 결과 내 최저가는 <br />
          최근 2주 동안 검색된 최저가 평균과 비슷합니다
        </span>
      </>
    );
  }
  return (
    <>
      <b className={cx('current')}>
        평균보다{' '}
        <i
          className={cx('percent')}
          data-compare={compare === Compare.HIGH ? 'high' : 'low'}
        >
          {rounded}%
        </i>
      </b>
      <span className={cx('desc')} role="row">
        검색 결과 내 최저가는 <br />
        최근 2주 동안 검색된 최저가 평균보다{' '}
        <b>
          {rounded}% {compare === Compare.HIGH ? '높은' : '낮은'} 가격
        </b>
        입니다
      </span>
    </>
  );
}
